<template>
    <div class="onboarding-tour__step">
        <div class="onboarding-tour__step-body">
            <div class="onboarding-tour__step-body__title">
                <h2>{{ header }}</h2>
            </div>
            <div class="onboarding-tour__step-body__content">
                <div v-if="text.includes('<')" v-html="text"></div>
                <p v-else>{{ text }}</p>
            </div>
        </div>
        <div class="onboarding-tour__step-img">
            <img :src="img" alt=" " />
        </div>
    </div>
    <div v-if="tips" class="onboarding-tour__step-tips">
        <VueFeather type="info" size="24" />
        <p>
            {{ tips }}
        </p>
    </div>
</template>

<script>
    import VueFeather from 'vue-feather';

    export default {
        components: {
            VueFeather,
        },
        props: {
            header: {
                type: String,
                required: true,
            },
            text: {
                type: String,
                required: true,
            },
            img: {
                type: String,
                required: true,
            },
            tips: {
                type: String,
                required: false,
            },
        },
        setup() {
            return {};
        },
    };
</script>
